import * as React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import DoneIcon from '@mui/icons-material/Done';
import SendIcon from '@mui/icons-material/Send';
import { Avatar, Button, Container, CssBaseline, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { Link, useLinkClickHandler } from 'react-router-dom'
import { RequireNonAuth, useAuth } from '../../Context/AuthContext';
import { LoadingButton } from '@mui/lab';
import { useParams, useNavigate } from 'react-router-dom'

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <a color="inherit" href="https://schwager.beer/">
        Schwager Bräu
      </a>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function ResetPW() {
  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)
  const params = useParams()
  const [t] = useTranslation()
  const auth = useAuth()
  const navigate = useNavigate()

  const handleClick = useLinkClickHandler("/login")

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true)
    const data = new FormData(event.currentTarget);
    // eslint-disable-next-line no-console
    auth.resetPW(params.token, data.get("password")).then(() => { 
      setLoading(false)
      setSuccess(true)
      window.setTimeout(() => navigate("/login"), 3000)
    }).catch(() => {
      setLoading(false)
    })
  };

  return (
    <RequireNonAuth>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {t("Password Recovery")}
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label={t("Password")}
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <LoadingButton
              loading={loading}
              loadingPosition="start"
              disabled={loading || success}
              startIcon={success ? <DoneIcon /> : <SendIcon />}
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              {t("Change Password")}
            </LoadingButton>
            <Button
              fullWidth
              variant="contained"
              color="inherit"
              sx={{ mt: 0, mb: 2 }}
              onClick={handleClick}
            >
              {t("Back to login")}
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </RequireNonAuth>
  );
}